<template>
    <b-navbar type="light" variant="light" toggleable="md" class="justify-content-md-end">
        <div class="pl-md-5">
            <b-navbar-brand to="/" class="brand-logo">GLF</b-navbar-brand>
        </div>
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-collapse is-nav id="nav_collapse">
                <b-navbar-nav class="ml-md-4">
                    <b-nav-item-dropdown :text="navbarContent.events" class="mr-md-1">
                        <b-dropdown-item
                            v-once
                            v-for="event in events"
                            :key="event.name"
                            :to="{
                                name: 'MomentDetails',
                                params: {slug: event.slug}
                            }"
                        >
                            {{ event.name }}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown :text="navbarContent.jewishHolidays">
                        <b-dropdown-item
                            v-once
                            v-for="jewishHoliday in jewishHolidays"
                            :key="jewishHoliday.name"
                            :to="{
                                name: 'MomentDetails',
                                params: {slug: jewishHoliday.slug}
                            }"
                        >
                            {{ jewishHoliday.name }}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item to="/about">{{ navbarContent.aboutUs }}</b-nav-item>
                </b-navbar-nav>
            </b-collapse>
    </b-navbar>
</template>

<script>
import store from '@/store';
export default {
    data() {
        return {
            navbarContent: store.navbar,
            jewishHolidays: store.jewishHolidays,
            events: store.events
        }
    }
}
</script>

<style scoped>
nav {
    position: sticky;
    top: 0;
    z-index: 99;
    transition: 0.3s all ease-in-out;
}
.brand-logo {
    font-size: 30px;
    font-weight: 700;
    color: #005b96 !important;
    transition: 0.2s;
    text-shadow: 1px 1px 1px #555;
}
</style>
